import { BaseDataService } from "../../../services/base/BaseDataService";
import { ActTemplate } from "../models/ActTemplate";
import { ActTemplateQuery } from "../models/ActTemplateQuery";

export class ActTemplatesService extends BaseDataService<
  ActTemplate,
  ActTemplateQuery
> {
  protected prefixUrl: string = `ActTemplates`;
}
